import React from 'react'
import TreatmentMain from '../components/TreatmentMain/TreatmentMain'
import TreatmentSection from '../components/TreatmentSection/TreatmentSection'
import AyurvedaFooter from '../components/AyurvedaFooter/AyurvedaFooter'
import ScrollToTop from '../components/ScrollToTop'
import WhatsAppButton from "../components/WhatsAppButton";
import ScrollTop from '../components/ScrollTop'
import { Helmet } from 'react-helmet-async';

export default function Treatments() {
  return (
    <>
  <Helmet>
  <title>
    Ayurvedic Treatments in Kerala
  </title>

  <meta
    name="description"
    content="Explore authentic Ayurvedic treatments at Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala. Our therapies include Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance & Yoga, and Soundarya Kalpa. Each treatment is rooted in classical Ayurveda, nature-inspired healing environment."
  />

  <meta
    name="keywords"
    content="Ayurvedic Treatments in Kozhikode  kerala, Ayurmoksha Treatments, Ayurveda Hospital Kozhikode kerala, Postnatal Care treatments in kozhikode Kerala, Rejuvenation Therapy in kozhikode Kerala, Ayurvedic Hair Treatment Kozhikode kerala, Lifestyle Guidance Ayurveda in kozhikode kerala, Yoga Therapy in kozhikode Kerala, Soundarya Kalpa Ayurveda treatment in kozhikode kerala, Traditional Ayurveda Hospital kozhikode Kerala"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/treatment" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Ayurvedic Treatments at Ayurmoksha | Kozhikode Kerala"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda Hospital in Kozhikode offers holistic Ayurvedic treatments including Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance & Yoga, and Soundarya Kalpa for complete mind-body healing."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/treatment"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda Hospital"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Ayurvedic Treatments at Ayurmoksha Ayurveda Hospital in Kozhikode"
  />

  <meta name="author" content="Ayurmoksha Ayurveda Hospital" />
</Helmet>


    <div>
      <ScrollTop/>
        <TreatmentMain/>
        <TreatmentSection/>
        <AyurvedaFooter />
        <ScrollToTop/>
         <WhatsAppButton />
    </div>
    </>
  )
}
